import { EventEmitter, OnInit, Input, Output, ViewChild, ElementRef, Directive } from '@angular/core';
import { FileType } from '@app/shared/models/file-type';
import { BaseComponent } from '@app/shared/components/base/base.component';

@Directive()
export class FileUploadComponent extends BaseComponent implements OnInit {

  @ViewChild('fileUploadElement')
  public fileUploadElement: ElementRef;

  @Input()
  public label: string;

  @Input()
  private acceptedFiles: FileType[];

  @Input()
  public multi?: boolean;

  public acceptFilesArray: string[];
  public acceptedFilesString: string;

  @Output()
  public filesSelected = new EventEmitter<File[]>();

  public fileList: FileList;

  constructor() {
    super();
  }

  public ngOnInit() {
   this.initAcceptedFiles();
  }

  private initAcceptedFiles(): void {
    this.acceptFilesArray = new Array<string>();
    this.acceptedFilesString = '';

    if (this.acceptedFiles && this.acceptedFiles.length > 0) {
      for (let i = 0; i < this.acceptedFiles.length; i++) {
        const ext = this.acceptedFiles[i].ext;
        this.acceptFilesArray.push(ext);
        this.acceptedFilesString += `${i === 0 ? `.` : `,.`}${ext}`;
      }
    }
  }

  public openFileUploadWindow(): void {
    const nativeFileInput = this.fileUploadElement.nativeElement;
    (<any>nativeFileInput.click)();
  }

  public onFilesChange(fileList: FileList) {
    this.fileList = fileList;
    this.handleFileInput();
  }

  public onFilesChangeEvent(event: Event) {
    this.fileList = (<any>event.target).files;
    this.handleFileInput();
  }

  protected handleFileInput(): void {
    if (this.fileList && this.fileList.length > 0) {
      const files = Array.from(this.fileList);
      this.filesSelected.emit(this.multi !== false ? files : [files[0]]);
      this.fileUploadElement.nativeElement.value = '';
    }
  }
}
